import {JsonAdapter} from "../helpers/JsonAdapter";

export class SiteLocation {
  id: string = "";
  name: string = "";

  static create(object:any): SiteLocation {
    const item = JsonAdapter.fill(new SiteLocation(), object);

    return item;
  }

  static createMultiple(objects: SiteLocation[]): SiteLocation[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(SiteLocation.create(objects[i]));
    }
    return items;
  }
}
